import { render, staticRenderFns } from "./ExternalUrl.vue?vue&type=template&id=84f9605a"
import script from "./ExternalUrl.vue?vue&type=script&lang=js"
export * from "./ExternalUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports